import ApiBuilder from "./ApiBuilder"
const { API } = ApiBuilder


const publishToPlatforms = async (releaseId, platfromIds) => {
  return API.post(`/api/publish/${releaseId}`, platfromIds)
}

const getApplicationReleasePlatforms = (releaseId) => {
  return API.get(`/api/publish/${releaseId}`)
}

const getPlatformSettings = (releaseId, platformId) => {
  return API.get(`/api/publish/app-release-platform/${releaseId}/${platformId}`)
}

const addOrUpdatePlatformSettings = async (ids, appPlatformSetting) => {
  const body = {
    id: ids?.appReleasePlatformId,
    applicationId: ids?.applicationId, 
    releaseId: ids?.releaseId,
    platformId: ids?.platformId,
    applicationPlatformSettingId: ids?.appPlatformSettingId,
    applicationPlatformSetting: appPlatformSetting
  }
  return API.post(`/api/publish/app-release-platform`, body)
}

export default {
  publishToPlatforms,
  getApplicationReleasePlatforms,
  getPlatformSettings,
  addOrUpdatePlatformSettings,
}